import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'outlined']),
  disabled: PropTypes.bool,
}

const defaultProps = {
  variant: 'primary',
  disabled: false,
}

const Button = props => {
  const { variant, disabled, onClick } = props
  let variantClasses
  switch (variant) {
    case 'primary':
      variantClasses = `bg-primary text-white text-lg shadow-lg hover:shadow`
      break
    case 'secondary':
      variantClasses = `bg-secondary text-white text-lg shadow-lg hover:shadow`
      break
    case 'tertiary':
      variantClasses = `bg-tertiary text-white text-lg shadow-lg hover:shadow`
      break
    case 'outlined':
      variantClasses = `bg-white text-secondary text-base border border-secondary`
      break
    default:
      variantClasses = `bg-white text-secondary `
  }

  let disabledClass = disabled ? `opacity-25 bg-body cursor-not-allowed` : ' '

  function handleClick() {
    if (disabled) {
      return
    } else if (onClick) {
      onClick()
    }
  }

  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      data-cy="action-btn"
      className={`flex w-full justify-center items-center py-4 rounded-lg font-semibold 
      cursor-pointer select-none outline-none border-0 transition ${variantClasses} ${disabledClass}`}
    >
      {props.children}
    </button>
  )
}

Button.propTypes = propTypes
Button.defaultProps = defaultProps

export default Button
